import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ping-timeline-slot',
  templateUrl: './timeline-slot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./timeline-slot.component.scss']
})
export class TimelineSlotComponent implements OnInit {

  @Input() item: any;
  @Input() hideImage: boolean;

  public imageUrl: string;
  public subscribed: boolean;

  constructor(private cd: ChangeDetectorRef,
      private router: Router,
    private utils: UtilitiesService) { }

  async ngOnInit() {
    const type = this.item['artistId'] ? 'artist' : 'entities';
    if (this.item.image && this.utils.validURL(this.item.image)) {
      this.imageUrl = this.item.image ? this.item.image : null;
    } else {
      if (this.item.image) {
        this.imageUrl = `${environment.aws.s3Url}${type}/200/`;
        this.imageUrl += this.item.image;
      }
    }
    this.cd.detectChanges();
  }


  public async openContent(item: any): Promise<any> {

  }

  public goToArtist(id: string): void {
    window.open(`${(!environment.production ? 'http://localhost:4200/' : 'https://ping-culture.com/')}artists/${id}`, '_blank');
  }

}
